<div class="container-fluid">
    <fap-layout></fap-layout>
</div>